import { r as w, c as v, h as s, H as g, g as m } from "./main-bb89b2f2.js";
import "vue";
const u = "*,:after,:before{border-color:var(--color-neutral-steel-200);border-style:solid;border-width:0;box-sizing:border-box}a{color:inherit;text-decoration:inherit}audio,canvas,embed,iframe,img,object,svg,video{display:block;vertical-align:middle}button,input,optgroup,select,textarea{font-feature-settings:inherit;color:inherit;font-family:inherit;font-size:100%;font-variation-settings:inherit;font-weight:inherit;letter-spacing:inherit;line-height:inherit;margin:0;padding:0}blockquote,dd,dl,fieldset,figure,h1,h2,h3,h4,h5,h6,hr,p,pre{margin:0}fieldset,legend{padding:0}.block{display:block}.flex{display:flex}.hidden{display:none}.flex-wrap{flex-wrap:wrap}.transition{transition-duration:.15s;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,-webkit-backdrop-filter;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter,-webkit-backdrop-filter;transition-timing-function:cubic-bezier(.4,0,.2,1)}:host{--inner-shadow-color:rgba(0,0,0,.2);display:block}.tab-container{display:flex;padding:var(--spacing-0);padding-top:var(--padding-top);scroll-behavior:smooth;transition:box-shadow .3s;-webkit-user-select:none;-moz-user-select:none;user-select:none}.tab-container--no-overflow,.tab-container--overflow{overflow:auto;overflow-y:hidden}.tab-container--no-overflow{height:auto;row-gap:12px}.tab-container::-webkit-scrollbar{height:8px}.tab-container::-webkit-scrollbar-track{background:inherit}.tab-container::-webkit-scrollbar-thumb{background:transparent}.tab-container:hover::-webkit-scrollbar-thumb{background:var(--color-steel-700)!important}.tab-container.innerShadowRight{box-shadow:inset -12px 0 9px -12px var(--inner-shadow-color),inset 0 0 0 0 var(--inner-shadow-color)}.tab-container.innerShadowLeft{box-shadow:inset 0 0 0 0 var(--inner-shadow-color),inset 9px 0 9px -7px var(--inner-shadow-color)}.tab-container.innerShadow{box-shadow:inset -12px 0 12px -12px var(--inner-shadow-color),inset 9px 0 9px -7px var(--inner-shadow-color)}.tab-container--size-small{height:42px}.tab-container--size-big{height:52px}@media (min-width:768px){.tab-container--no-overflow{flex-wrap:wrap}}@media (min-width:1280px){.tab-container--no-overflow{row-gap:4px}}.static{position:static}.resize{resize:both}.filter{filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}", x = u, k = class {
  handleResize() {
    this.checkScrollOverflow(this.activeItemId);
  }
  /**
   * Public function to set the active tab
   */
  async setTabToActive(t) {
    this.openTab(t), this.checkScrollOverflow(t);
  }
  constructor(t) {
    w(this, t), this.changeEvent = v(this, "lhChange", 7), this.alignItems = "center", this.controlled = !1, this.customHeight = void 0, this.noOverflow = !1, this.noOverflowShadow = !1, this.paddingTop = "0px", this.size = "big", this.subtle = void 0, this.trackScroll = this.trackScroll.bind(this);
  }
  componentWillLoad() {
    this.scrollPos = 0, this.hostElement.style.setProperty("--padding-top", "0px");
  }
  componentDidLoad() {
    this.checkScrollOverflow(this.activeItemId);
  }
  componentDidUpdate() {
    this.checkScrollOverflow(this.activeItemId);
  }
  openTab(t) {
    var e;
    (e = this.queryTabItems().filter((o) => o.itemId == t)) === null || e === void 0 || e.map((o) => {
      o.active = !0;
    }), this.unselectAllOther(t);
  }
  trackScroll() {
    const t = this.tabContainer, e = t.clientWidth, i = t.scrollWidth, o = t.scrollLeft, r = 16, n = i - e;
    this.scrollPos = o, this.noOverflowShadow || (t.classList.add("innerShadow"), o > n - r ? (t.classList.remove("innerShadow", "innerShadowRight"), t.classList.add("innerShadowLeft")) : o < r ? (t.classList.remove("innerShadow", "innerShadowLeft"), t.classList.add("innerShadowRight")) : t.classList.remove("innerShadowRight", "innerShadowLeft"));
  }
  checkScrollOverflow(t) {
    if (this.activeItemId != null && this.tabContainer != null) {
      const i = this.tabContainer.clientWidth;
      this.tabContainer.scrollWidth - 2 > i ? (!this.noOverflowShadow && this.tabContainer.classList.add("innerShadowRight"), this.hostElement.style.setProperty("--padding-top", this.paddingTop)) : (!this.noOverflowShadow && this.tabContainer.classList.remove("innerShadowRight", "innerShadowLeft"), this.hostElement.style.setProperty("--padding-top", "0px"));
      const r = this.queryTabItems();
      r != null && r.length > 0 && r.filter((n) => n.itemId === t).map((n) => {
        if (n != null) {
          const a = n.getBoundingClientRect(), l = this.tabContainer.getBoundingClientRect(), c = l.x, h = l.x + i, d = a.x, b = a.x + a.width, f = this.scrollPos + (d - c) - 48, p = this.scrollPos + (b - h) + 48;
          d < c ? this.tabContainer.scrollTo(f, 0) : b > h && this.tabContainer.scrollTo(p, 0);
        }
      });
    }
  }
  onItemActivation(t) {
    const e = t.detail;
    this.activeItemId !== e && (this.controlled || (this.activeItemId = e, this.openTab(e)), this.checkScrollOverflow(e), this.changeEvent.emit({ value: e }));
  }
  unselectAllOther(t) {
    this.queryTabItems().filter((o) => o.itemId != t).map((o) => {
      o.active = !1;
    });
  }
  queryTabItems() {
    var t;
    const e = this.hostElement.shadowRoot.querySelector("slot");
    return ((t = e == null ? void 0 : e.assignedNodes().filter((o) => o.nodeName === "PATTERNLIB-TABS-ITEM")) !== null && t !== void 0 ? t : []).map((o) => o);
  }
  render() {
    return s(g, { key: "258cbcedd598434d001849598e3dc7b639378100" }, s("div", { key: "28becfc0ba8726efe00826c71b78b7718ee3dec8", role: "tablist", "aria-label": "List of Tabs", class: {
      "tab-container": !0,
      "tab-container--no-overflow": this.noOverflow,
      [`tab-container--overflow tab-container--size-${this.size}`]: !this.noOverflow
    }, style: {
      alignItems: this.alignItems,
      height: this.customHeight
    }, onScroll: this.trackScroll, ref: (t) => {
      this.tabContainer = t;
    } }, s("slot", { key: "0c5dfb15a4a471d91df76b939db86e5eb97ce469" })));
  }
  get hostElement() {
    return m(this);
  }
};
k.style = x;
export {
  k as patternlib_tabs
};
